import React, { useState } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Checkbox, InputNumber, Popconfirm, Card, Divider, DatePicker, Select, Row, Col, Form, Input, Button, Icon, message } from 'antd';
import { editCandidate } from './../API';
import { allNations } from './../utils/countries';
import Flag from "react-country-flags";
import moment from 'moment';
import { useMappedState, useDispatch } from 'redux-react-hook';
import { flexCenter, flexCenterRight, formItemLayout } from './../theme';
const { Option } = Select;
const { TextArea } = Input;

const cvFormItemLayout1 = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

const cvFormItemLayout2 = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 },
};

function EditCandidate({form}) {
  const nations = allNations()
  const { getFieldDecorator } = form;

  const session = useMappedState(state => state.session);
  const candidate = useMappedState(state => state.candidate);
  const dispatch = useDispatch();

  const [editLoading, setEditLoading] = useState(false);

  const getOtherTitle1 = () => {
    if (candidate.cvBody && candidate.cvBody.otherTitle1) {
      return candidate.cvBody.otherTitle1
    }
    return null;
  }

  const getOtherTitle2 = () => {
    if (candidate.cvBody && candidate.cvBody.otherTitle2) {
      return candidate.cvBody.otherTitle2
    }
    return null;
  }

  const getOtherTitle3 = () => {
    if (candidate.cvBody && candidate.cvBody.otherTitle3) {
      return candidate.cvBody.otherTitle3
    }
    return null;
  }

  async function getDescArr() {
    const formResult = await form.getFieldsValue();
    const arr = []
    for (let i = 0; i < description.length; i++) {
      arr.push(formResult[`candidate-description-${i}`])
    }
    return arr;
  }

  async function getQualArr() {
    const formResult = await form.getFieldsValue();
    const arr = []
    for (let i = 0; i < qualification.length; i++) {
      arr.push({
        text: formResult[`candidate-qualification-${i}`],
        from: formResult[`candidate-qualification-from-${i}`],
        to: formResult[`candidate-qualification-to-${i}`],
      })
    }
    return arr;
  }

  async function getEducArr() {
    const formResult = await form.getFieldsValue();
    const arr = []
    for (let i = 0; i < education.length; i++) {
      arr.push({
        from: formResult[`candidate-education-from-${i}`],
        to: formResult[`candidate-education-to-${i}`],
        text: formResult[`candidate-education-${i}`],
      })

    }
    return arr;
  }

  async function getOther1Arr() {
    const formResult = await form.getFieldsValue();
    const arr = []
    for (let i = 0; i < other1.length; i++) {
      arr.push(formResult[`candidate-other1-${i}`])
    }
    return arr;
  }

  async function getOther2Arr() {
    const formResult = await form.getFieldsValue();
    const arr = []
    for (let i = 0; i < other2.length; i++) {
      arr.push(formResult[`candidate-other2-${i}`])
    }
    return arr;
  }

  async function getOther3Arr() {
    const formResult = await form.getFieldsValue();
    const arr = []
    for (let i = 0; i < other3.length; i++) {
      arr.push(formResult[`candidate-other3-${i}`])
    }
    return arr;
  }

  const addWorkTextDesc = (k, numStr) => {
    const work = form.getFieldValue('work');
    const temp = work[k];

    if (temp.textDesc) {
      work[k] = {
        ...temp,
        ...{
          textDesc: [
            ...temp.textDesc, 
            ...[{type: `Level-${numStr}`, text: ''}]
          ]
        }
      }
    } else {
      work[k] = {
        ...temp,
        ...{
          textDesc: [{type: `Level-${numStr}`, text: ''}]
        },
      }
    }

    form.setFieldsValue({
      work: work
    });
  };

  async function getWorkArr() {
    const formResult = await form.getFieldsValue();
    const arr = []
    for (let i = 0; i < work.length; i++) {

      let textDescArr = [];
      for (let j = 0; j < work[i].textDesc.length; j++) {
        textDescArr.push({
          type: work[i].textDesc[j].type,
          text: formResult[`candidate-work-${i}-textDesc-${j}`],
        });
      }

      arr.push({
        from: formResult[`candidate-work-from-${i}`],
        to: formResult[`candidate-work-to-${i}`],
        text: formResult[`candidate-work-text-${i}`],
        footer: formResult[`candidate-work-footer-${i}`],
        space: formResult[`candidate-work-space-${i}`],
        textDesc: textDescArr,
        company: formResult[`candidate-work-company-${i}`],
        companyDesc: formResult[`candidate-work-companyDesc-${i}`],
        position: formResult[`candidate-work-position-${i}`],
      })
    }

    return arr;
  }

  const handleOnAddNewOnTop = async e => {
    try {
      e.preventDefault();
      const formResult = await form.validateFields();
      setEditLoading(true);

      const newData = {
        "from": null,
        "to": null,
        "text": "",
        "footer": "",
        "space": 0,
        "textDesc": [],
        "company": "",
        "companyDesc": "",
        "position": ""
      };
  
      const cvBody = candidate.cvBody;
      const workArray = cvBody.work;
      workArray.unshift(newData);
      
      const result = await editCandidate(session.authToken, {
        ...{
          cvBody,
          dob: formResult.dob,
          country: formResult.country,
          email: formResult.email,
          email1: formResult.email1,
          email2: formResult.email2,
          linkedin: formResult.linkedin,
          location: formResult.location,
          mobile: formResult.mobile,
          othercontact: formResult.othercontact,
          position: formResult.position,
          region: formResult.region,
          salutation: formResult.salutation,
          service: formResult.service,
          source: formResult.source,
          wechat: formResult.wechat,
          whatsapp: formResult.whatsapp,
          bothSide: formResult.bothSide,
        },
        ...{firstname: candidate.firstname, lastname: candidate.lastname},
        ...{id: candidate.id},
      });
      setEditLoading(false);
  
      if (result.data.responseCode === 0) {
        message.warning('A new employment history entry has been added, this page will be reload again!');
        setTimeout(() => {
          window.location.reload()
        }, 3000);
      }
      else {
        dispatch({type: "OPEN_MSG_MODAL", payload: result.data.message});
      }
    } catch (e) {
      message.error("You have required field need to fill!")
    }
  }

  const handleSubmit = async e => {
    try {
      e.preventDefault();
      const formResult = await form.validateFields();
      setEditLoading(true);
  
      let cvBody = {};
  
      const arrDescription = [];
      for (let i = 0; i < formResult.description.length; i++) {
        arrDescription.push(formResult[`candidate-description-${i}`])
      }
  
      const arrQualification = [];
      for (let i = 0; i < formResult.qualification.length; i++) {
        arrQualification.push({
          text: formResult[`candidate-qualification-${i}`],
          from: formResult[`candidate-qualification-from-${i}`],
          to: formResult[`candidate-qualification-to-${i}`],
        })
      }
  
      const arrEducation = [];
      for (let i = 0; i < formResult.education.length; i++) {
        arrEducation.push({
          from: formResult[`candidate-education-from-${i}`],
          to: formResult[`candidate-education-to-${i}`],
          text: formResult[`candidate-education-${i}`],
        });
      }
  
      const arrOther1 = [];
      for (let i = 0; i < formResult.other1.length; i++) {
        arrOther1.push(formResult[`candidate-other1-${i}`])
      }
  
      const arrOther2 = [];
      for (let i = 0; i < formResult.other2.length; i++) {
        arrOther2.push(formResult[`candidate-other2-${i}`])
      }
  
      const arrOther3 = [];
      for (let i = 0; i < formResult.other3.length; i++) {
        arrOther3.push(formResult[`candidate-other3-${i}`])
      }
  
      const arrWork = [];
      for (let i = 0; i < formResult.work.length; i++) {
  
        let textDescArr = [];
        if (formResult.work[i].textDesc) {
          for (let j = 0; j < formResult.work[i].textDesc.length; j++) {
            textDescArr.push({
              type: formResult.work[i].textDesc[j].type,
              text: formResult[`candidate-work-${i}-textDesc-${j}`]
            });
          }
        }
  
        arrWork.push({
          from: formResult[`candidate-work-from-${i}`],
          to: formResult[`candidate-work-to-${i}`],
          text: formResult[`candidate-work-text-${i}`],
          footer: formResult[`candidate-work-footer-${i}`],
          space: formResult[`candidate-work-space-${i}`],
          textDesc: textDescArr,
          company: formResult[`candidate-work-company-${i}`],
          companyDesc: formResult[`candidate-work-companyDesc-${i}`],
          position: formResult[`candidate-work-position-${i}`],
        });
      }
  
      if (arrDescription.length > 0) {
        cvBody = {
          ...cvBody,
          ...{description: arrDescription},
        }
      }
  
      if (arrQualification.length > 0) {
        cvBody = {
          ...cvBody,
          ...{qualification: arrQualification},
        }
      }
  
      if (arrEducation.length > 0) {
        cvBody = {
          ...cvBody,
          ...{education: arrEducation},
        }
      }
  
      if (arrWork.length > 0) {
        cvBody = {
          ...cvBody,
          ...{work: arrWork},
        }
      }
  
      if (arrOther1.length > 0) {
        cvBody = {
          ...cvBody,
          ...{other1: arrOther1},
        }
      }
  
      if (arrOther2.length > 0) {
        cvBody = {
          ...cvBody,
          ...{other2: arrOther2},
        }
      }
  
      if (arrOther3.length > 0) {
        cvBody = {
          ...cvBody,
          ...{other3: arrOther3},
        }
      }
  
      if (formResult.otherTitle1) {
        cvBody = {
          ...cvBody,
          ...{otherTitle1: formResult.otherTitle1}
        }
      }
  
      if (formResult.otherTitle2) {
        cvBody = {
          ...cvBody,
          ...{otherTitle2: formResult.otherTitle2}
        }
      }
  
      if (formResult.otherTitle3) {
        cvBody = {
          ...cvBody,
          ...{otherTitle3: formResult.otherTitle3}
        }
      }
  
      const result = await editCandidate(session.authToken, {
        ...{
          cvBody,
          dob: formResult.dob,
          country: formResult.country,
          email: formResult.email,
          email1: formResult.email1,
          email2: formResult.email2,
          linkedin: formResult.linkedin,
          location: formResult.location,
          mobile: formResult.mobile,
          othercontact: formResult.othercontact,
          position: formResult.position,
          region: formResult.region,
          salutation: formResult.salutation,
          service: formResult.service,
          source: formResult.source,
          wechat: formResult.wechat,
          whatsapp: formResult.whatsapp,
          bothSide: formResult.bothSide,
        },
        ...{firstname: formResult.firstname.trim(), lastname: formResult.lastname.trim()},
        ...{id: candidate.id},
      });
      setEditLoading(false);
  
      if (result.data.responseCode === 0) {
        dispatch({type: "INIT_CANDIDATE", payload: {
          ...formResult,
          ...{
            id: candidate.id,
            avatar: candidate.avatar,
            notes: candidate.notes,
            events: candidate.events,
            cvBody,
          }
        }});
        message.success(result.data.message);
      }
      else {
        dispatch({type: "OPEN_MSG_MODAL", payload: result.data.message});
      }
    } catch (e) {
      message.error("You have required field need to fill!")
    }
  };

  const countrySelection = [];
  for (let i = 0; i < nations.length; i++) {
    countrySelection.push(
      <Option key={i} value={nations[i].name} label={nations[i].name}>
        <Row>
          <Col span={4}>
            <Flag country={nations[i].code} asSquare={true} style={{width: '30px', height: '20px'}}/>
          </Col>
          <Col>
            {nations[i].name}
          </Col>
        </Row>
      </Option>
    )
  }

  getFieldDecorator('description', { initialValue: candidate.cvBody && candidate.cvBody.description ? candidate.cvBody.description : [] });
  const description = form.getFieldValue('description');

  getFieldDecorator('qualification', { initialValue: candidate.cvBody && candidate.cvBody.qualification ? candidate.cvBody.qualification : [] });
  const qualification = form.getFieldValue('qualification');

  getFieldDecorator('education', { initialValue: candidate.cvBody && candidate.cvBody.education ? candidate.cvBody.education : [] });
  const education = form.getFieldValue('education');

  getFieldDecorator('work', { initialValue: candidate.cvBody && candidate.cvBody.work ? candidate.cvBody.work : [] });
  const work = form.getFieldValue('work');

  getFieldDecorator('other1', { initialValue: candidate.cvBody && candidate.cvBody.other1 ? candidate.cvBody.other1 : [] });
  const other1 = form.getFieldValue('other1');

  getFieldDecorator('other2', { initialValue: candidate.cvBody && candidate.cvBody.other2 ? candidate.cvBody.other2 : [] });
  const other2 = form.getFieldValue('other2');

  getFieldDecorator('other3', { initialValue: candidate.cvBody && candidate.cvBody.other3 ? candidate.cvBody.other3 : [] });
  const other3 = form.getFieldValue('other3');


  async function reorder(list, startIndex, endIndex, type) {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    for (let i = 0; i < result.length; i++) {
      form.setFieldsValue({
        [`candidate-${type}-${i}`]: result[i]
      });
    }
    return result;
  };

  async function onDragEndDescription(result) {
    if (!result.destination) {
      return;
    }
    const description = await getDescArr();
    reorder(description, result.source.index, result.destination.index, 'description')
  };

  async function onDragEndOther1(result) {
    if (!result.destination) {
      return;
    }
    const other1 = await getOther1Arr();
    reorder(other1, result.source.index, result.destination.index, 'other1')
  };

  async function onDragEndOther2(result) {
    if (!result.destination) {
      return;
    }
    const other2 = await getOther2Arr();
    reorder(other2, result.source.index, result.destination.index, 'other2')
  };


  async function onDragEndOther3(result) {
    if (!result.destination) {
      return;
    }
    const other3 = await getOther3Arr();
    reorder(other3, result.source.index, result.destination.index, 'other3')
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Row>
        <Col span={12}>
          <div style={{marginRight: '10px'}}>
            <Form.Item {...formItemLayout} label="Salutation">
              {getFieldDecorator('salutation', {
                initialValue: candidate.salutation
              })(
                <Input autoComplete="off" placeholder="Salutation" disabled={editLoading} />
              )}
            </Form.Item>

            <Form.Item {...formItemLayout} label="First Name">
              {getFieldDecorator('firstname', {
                initialValue: candidate.firstname,
                rules: [{ required: true, message: 'Please input firstname!' }],
              })(
                <Input autoComplete="off" placeholder="First Name" disabled={editLoading} />
              )}
            </Form.Item>

            <Form.Item {...formItemLayout} label="Last Name">
              {getFieldDecorator('lastname', {
                initialValue: candidate.lastname,
                rules: [{ required: true, message: 'Please input lastname!' }],
              })(
                <Input autoComplete="off" placeholder="Last Name" disabled={editLoading} />
              )}
            </Form.Item>

            <Form.Item {...formItemLayout} label="Country">
              {getFieldDecorator('country', {
                initialValue: candidate.country,
              })(
                <Select
                  disabled={editLoading}
                  placeholder="Country"
                  optionLabelProp="label"
                  showSearch
                >
                {countrySelection}
                </Select>
              )}
            </Form.Item>

            <Form.Item {...formItemLayout} label="Region">
              {getFieldDecorator('region', {
                initialValue: candidate.region
              })(
                <Input autoComplete="off" placeholder="Region" disabled={editLoading} />
              )}
            </Form.Item>

            <Form.Item {...formItemLayout} label="Birthday">
              {getFieldDecorator('dob', {
                initialValue: candidate.dob ? moment(candidate.dob) : null,
              })(
                <DatePicker placeholder="Date of Birth" style={{width: "100%"}} disabled={editLoading} />
              )}
            </Form.Item>

            <Form.Item {...formItemLayout} label="Email">
              {getFieldDecorator('email', {
                initialValue: candidate.email,
                rules: [
                  {
                    type: "email",
                    message: "Please input valid email!",
                  },
                  {
                    required: true,
                    message: "Please input email!"
                  }
                ],
              })(
                <Input autoComplete="off" placeholder="Email" disabled={editLoading} />
              )}
            </Form.Item>

            <Form.Item {...formItemLayout} label="Optional Email 1">
              {getFieldDecorator('email1', {
                initialValue: candidate.email1,
                rules: [
                  {
                    type: "email",
                    message: "Please input valid email!",
                  }
                ],
              })(
                <Input autoComplete="off" placeholder="Optional Email 1" disabled={editLoading} />
              )}
            </Form.Item>

            <Form.Item {...formItemLayout} label="Optional Email 2">
              {getFieldDecorator('email2', {
                initialValue: candidate.email2,
                rules: [
                  {
                    type: "email",
                    message: "Please input valid email!",
                  }
                ],
              })(
                <Input autoComplete="off" placeholder="Optional Email 2" disabled={editLoading} />
              )}
            </Form.Item>

            <Form.Item {...formItemLayout} label="Is Contact">
              {getFieldDecorator('bothSide', {
                initialValue: candidate.bothSide,
                valuePropName: 'checked'
              })(<Checkbox>{candidate.bothSide}</Checkbox>)}
            </Form.Item>
          </div>
        </Col>
        <Col span={12}>
          <div style={{marginLeft: '10px'}}>
            <Form.Item {...formItemLayout} label="Mobile">
              {getFieldDecorator('mobile', {
                initialValue: candidate.mobile
              })(
                <Input autoComplete="off" placeholder="Mobile" disabled={editLoading} />
              )}
            </Form.Item>

            <Form.Item {...formItemLayout} label="Location">
              {getFieldDecorator('location', {
                initialValue: candidate.location,
                rules: [{ required: true, message: 'Please input location!' }],
              })(
                <Input autoComplete="off" placeholder="Location" disabled={editLoading} />
              )}
            </Form.Item>

            <Form.Item {...formItemLayout} label="Service">
              {getFieldDecorator('service', {
                initialValue: candidate.service
              })(
                <Input autoComplete="off" placeholder="Service" disabled={editLoading} />
              )}
            </Form.Item>

            <Form.Item {...formItemLayout} label="Position">
              {getFieldDecorator('position', {
                initialValue: candidate.position
              })(
                <Input autoComplete="off" placeholder="Position" disabled={editLoading} />
              )}
            </Form.Item>

            <Form.Item {...formItemLayout} label="LinkedIn">
              {getFieldDecorator('linkedin', {
                initialValue: candidate.linkedin
              })(
                <Input autoComplete="off" placeholder="Linkedin" disabled={editLoading} />
              )}
            </Form.Item>

            <Form.Item {...formItemLayout} label="Wechat">
              {getFieldDecorator('wechat', {
                initialValue: candidate.wechat
              })(
                <Input autoComplete="off" placeholder="Wechat" disabled={editLoading} />
              )}
            </Form.Item>

            <Form.Item {...formItemLayout} label="Whats app">
              {getFieldDecorator('whatsapp', {
                initialValue: candidate.whatsapp
              })(
                <Input autoComplete="off" placeholder="Whats app" disabled={editLoading} />
              )}
            </Form.Item>

            <Form.Item {...formItemLayout} label="Other Contact">
              {getFieldDecorator('othercontact', {
                initialValue: candidate.othercontact
              })(
                <Input autoComplete="off" placeholder="Other Contact" disabled={editLoading} />
              )}
            </Form.Item>

            <Form.Item {...formItemLayout} label="Source">
              {getFieldDecorator('source', {
                initialValue: candidate.source
              })(
                <Input autoComplete="off" placeholder="Source" disabled={editLoading} />
              )}
            </Form.Item>
          </div>
        </Col>
      </Row>

      <Divider />

      <Row>
        <Col span={24}>
          <Card size="small" title="Descriptions" extra={
            <Button type="primary" disabled={editLoading} size="small" onClick={() => {
              const description = form.getFieldValue('description');
              form.setFieldsValue({
                description: [...description, ...['']]
              });
            }}><Icon type="plus" />Add New</Button>
          }>
            {
              description.length > 0 ? (
                <DragDropContext onDragEnd={onDragEndDescription}>
                  <Droppable droppableId="drag-drop">
                    {(provided) => (
                      <div
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                      >
                        {description.map((i, k) => (
                          <Draggable
                            key={`${i}-${k}`}
                            draggableId={`${i}-${k}`}
                            index={k}
                          >
                            {(p) => (
                              <div
                                ref={p.innerRef}
                                {...p.draggableProps}
                                {...p.dragHandleProps}
                              >
                                <Row key={k}>
                                  <Col span={1}>
                                    <center style={{marginTop: '15px'}}>
                                      <Icon type="menu" />
                                    </center>
                                  </Col>
                                  <Col span={22}>
                                    <Form.Item>
                                      {getFieldDecorator(`candidate-description-${k}`, {
                                        initialValue: i,
                                        rules: [{ required: true, message: 'Please input!' }],
                                      })(
                                        <TextArea style={{resize: 'none'}} rows={2} autoComplete="off" disabled={editLoading} />
                                      )}
                                    </Form.Item>
                                  </Col>
                                  <Col span={1} style={flexCenter} >
                                    <center style={{marginTop: '15px'}}>
                                      <Popconfirm
                                        placement="left"
                                        title="Are you sure to delete this?"
                                        onConfirm={async () => {
                                          const arr = await getDescArr();
                                          arr.splice(k, 1);
                                          for (let i = 0; i < arr.length; i++) {
                                            form.setFieldsValue({
                                              [`candidate-description-${i}`]: arr[i]
                                            });
                                          }
                                          form.setFieldsValue({
                                            description: arr
                                          });
                                        }}
                                        okText="Yes"
                                        cancelText="No"
                                      >
                                        <Icon type="delete" />
                                      </Popconfirm>
                                    </center>
                                  </Col>
                                </Row>
                              </div>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              ) : <div style={{color: '#cccccc'}}>No description available</div>}
          </Card>
        </Col>
      </Row>

      <br/>
      <Row>
        <Col span={24}>
          <Card size="small" title="Qualifications:" extra={
            <Button type="primary" disabled={editLoading} size="small" onClick={() => {
              const qualification = form.getFieldValue('qualification');
              form.setFieldsValue({
                qualification: [...qualification, ...[{
                  text: '',
                  from: null,
                  to: null,
                }]]
              });
            }}><Icon type="plus" />Add New</Button>
          }>
            {
              qualification.length > 0 ? (
                <>
                  {qualification.map((i, k) => (
                    <Row key={k}>
                      <Col span={1} style={flexCenter}>
                        <center>
                          <Popconfirm
                            placement="right"
                            title="Are you sure to delete this?"
                            onConfirm={async () => {
                              const arr = await getQualArr();
                              arr.splice(k, 1);
                              for (let i = 0; i < arr.length; i++) {
                                form.setFieldsValue({
                                  [`candidate-qualification-${i}`]: arr[i]['text']
                                });
                                form.setFieldsValue({
                                  [`candidate-qualification-from-${i}`]: arr[i]['from']
                                });
                                form.setFieldsValue({
                                  [`candidate-qualification-to-${i}`]: arr[i]['to']
                                });
                              }
                              form.setFieldsValue({
                                qualification: arr
                              });
                            }}
                            okText="Yes"
                            cancelText="No"
                          >
                            <Icon type="delete" />
                          </Popconfirm>
                        </center>
                      </Col>
                      <Col span={23}>
                        <Row>
                          <Col span={12}>
                            <Form.Item {...cvFormItemLayout1} label="From">
                              {getFieldDecorator(`candidate-qualification-from-${k}`, {
                                initialValue: i.from,
                              })(
                                <Input autoComplete="off" disabled={editLoading} addonAfter={<Icon type="calendar" />} placeholder="example: 2022-01 or 2022" />
                              )}
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item {...cvFormItemLayout1} label="To">
                              {getFieldDecorator(`candidate-qualification-to-${k}`, {
                                initialValue: i.to,
                              })(
                                <Input autoComplete="off" disabled={editLoading} addonAfter={<Icon type="calendar" />} placeholder="example: 2022-01 or 2022" />
                              )}
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row>
                          <Form.Item {...cvFormItemLayout2} label="Details" >
                            {getFieldDecorator(`candidate-qualification-${k}`, {
                              initialValue: i.text,
                              rules: [{ required: true, message: 'Please input!' }],
                            })(
                              <TextArea style={{resize: 'none'}} rows={4} autoComplete="off" disabled={editLoading} />
                            )}
                          </Form.Item>
                        </Row>
                      </Col>
                    </Row>
                  ))}
                </>
              ) : <div style={{color: '#cccccc'}}>No qualification available</div>}
          </Card>
        </Col>
      </Row>

      <br/>
      <Row>
        <Col span={24}>
          <Card size="small" title="Educations:" extra={
            <Button type="primary" disabled={editLoading} size="small" onClick={() => {
              const education = form.getFieldValue('education');
              form.setFieldsValue({
                education: [...education, ...[{
                  text: '',
                  from: null,
                  to: null,
                }]]
              });
            }}><Icon type="plus" />Add New</Button>
          }>
            {
              education.length > 0 ? (
                <>
                  {education.map((i, k) => (
                    <Row key={k}>
                      <Col span={1} style={flexCenter} >
                          <center>
                            <Popconfirm
                              placement="right"
                              title="Are you sure to delete this?"
                              onConfirm={async () => {
                                const arr = await getEducArr();
                                arr.splice(k, 1);
                                for (let i = 0; i < arr.length; i++) {
                                  form.setFieldsValue({
                                    [`candidate-education-${i}`]: arr[i]['text']
                                  });
                                  form.setFieldsValue({
                                    [`candidate-education-from-${i}`]: arr[i]['from']
                                  });
                                  form.setFieldsValue({
                                    [`candidate-education-to-${i}`]: arr[i]['to']
                                  });
                                }
                                form.setFieldsValue({
                                  education: arr
                                });
                              }}
                              okText="Yes"
                              cancelText="No"
                            >
                              <Icon type="delete" />
                            </Popconfirm>
                          </center>
                        </Col>
                      
                      <Col span={23}>
                        <Row>
                          <Col span={12}>
                            <Form.Item {...cvFormItemLayout1} label="From">
                              {getFieldDecorator(`candidate-education-from-${k}`, {
                                initialValue: i.from,
                              })(
                                <Input autoComplete="off" disabled={editLoading} addonAfter={<Icon type="calendar" />} placeholder="example: 2022-01 or 2022" />
                              )}
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item {...cvFormItemLayout1} label="To">
                              {getFieldDecorator(`candidate-education-to-${k}`, {
                                initialValue: i.to,
                              })(
                                <Input autoComplete="off" disabled={editLoading} addonAfter={<Icon type="calendar" />} placeholder="example: 2022-01 or 2022" />
                              )}
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row>
                          <Form.Item {...cvFormItemLayout2} label="Details">
                            {getFieldDecorator(`candidate-education-${k}`, {
                              initialValue: i.text,
                              rules: [{ required: true, message: 'Please input!' }],
                            })(
                              <TextArea style={{resize: 'none'}} rows={4} autoComplete="off" disabled={editLoading} />
                            )}
                          </Form.Item>
                        </Row>
                      </Col>
                    </Row>
                  ))}
                </>
              ) : <div style={{color: '#cccccc'}}>No education available</div>}
          </Card>
        </Col>
      </Row>

      <br/ >
      <Row>
        <Col span={24}>
          <Card size="small" title="Employment Histories" extra={
            <div>
              {candidate.cvBody && candidate.cvBody.work && candidate.cvBody.work.length > 0 ? (
                <Button type="primary" disabled={editLoading} size="small" onClick={handleOnAddNewOnTop}><Icon type="plus" />Add New On Top</Button>
              ) : null}
              &nbsp;
              <Button type="primary" disabled={editLoading} size="small" onClick={() => {
                const work = form.getFieldValue('work');
                form.setFieldsValue({
                  work: [
                    ...work, 
                    ...[{
                      from: null,
                      to: null,
                      text: '',
                      footer: '',
                      space: 0,
                      company: '',
                      companyDesc: '',
                      position: '',
                      textDesc: [],
                      
                    }]
                  ]
                });
              }}><Icon type="plus" />Add New</Button>
            </div>
          }>
            {
              work && work.length > 0 ? (
                <div>
                  {work.map((i, k) => (
                    <div key={k}>
                          <Row>
                          <Col span={1}>
                            <Row>
                              <center>
                              <Popconfirm
                                  placement="right"
                                  title="Are you sure to delete this?"
                                  onConfirm={async () => {
                                    const arr = await getWorkArr();
                                    arr.splice(k, 1);
                                    for (let i = 0; i < arr.length; i++) {

                                      for (let j = 0; j < arr[i].textDesc.length; j++) {
                                        form.setFieldsValue({
                                          [`candidate-work-${i}-textDesc-${j}`]: arr[i]['textDesc'][j]['text']
                                        });
                                      }

                                      form.setFieldsValue({
                                        [`candidate-work-from-${i}`]: arr[i]['from']
                                      });
                                      form.setFieldsValue({
                                        [`candidate-work-to-${i}`]: arr[i]['to']
                                      });
                                      form.setFieldsValue({
                                        [`candidate-work-text-${i}`]: arr[i]['text']
                                      });
                                      form.setFieldsValue({
                                        [`candidate-work-footer-${i}`]: arr[i]['footer']
                                      });
                                      form.setFieldsValue({
                                        [`candidate-work-space-${i}`]: arr[i]['space']
                                      });
                                      form.setFieldsValue({
                                        [`candidate-work-company-${i}`]: arr[i]['company']
                                      });
                                      form.setFieldsValue({
                                        [`candidate-work-companyDesc-${i}`]: arr[i]['companyDesc']
                                      });
                                      form.setFieldsValue({
                                        [`candidate-work-position-${i}`]: arr[i]['position']
                                      });
                                    }
                                    form.setFieldsValue({
                                      work: arr
                                    });
                                  }}
                                  okText="Yes"
                                  cancelText="No"
                                >
                                  <Icon type="delete" />
                                </Popconfirm>
                                </center>
                            </Row>
                          </Col>
                          <Col span={23}>
                            <Row>
                              <Col span={12}>
                                <Form.Item {...cvFormItemLayout1} label="From">
                                  {getFieldDecorator(`candidate-work-from-${k}`, {
                                    initialValue: i.from,
                                  })(
                                    <Input autoComplete="off" disabled={editLoading} addonAfter={<Icon type="calendar" />} placeholder="example: 2022-01 or 2022" />
                                  )}
                                </Form.Item>
                              </Col>
                              <Col span={12}>
                                <Form.Item {...cvFormItemLayout1} label="To">
                                  {getFieldDecorator(`candidate-work-to-${k}`, {
                                    initialValue: i.to,
                                  })(
                                    <Input autoComplete="off" disabled={editLoading} addonAfter={<Icon type="calendar" />} placeholder="example: 2022-01 or 2022" />
                                  )}
                                </Form.Item>
                              </Col>
                            </Row>
                            <Row>
                              <Form.Item {...cvFormItemLayout2} label="Company">
                                {getFieldDecorator(`candidate-work-company-${k}`, {
                                  initialValue: i.company,
                                  rules: [{ required: true, message: 'Please input!' }],
                                })(
                                  <Input autoComplete="off" disabled={editLoading} />
                                )}
                              </Form.Item>
                            </Row>
                            <Row>
                              <Form.Item {...cvFormItemLayout2} label="Company Desc">
                                {getFieldDecorator(`candidate-work-companyDesc-${k}`, {
                                  initialValue: i.companyDesc,
                                })(
                                  <TextArea style={{resize: 'none'}} rows={2} autoComplete="off" disabled={editLoading} />
                                )}
                              </Form.Item>
                            </Row>
                            <Row>
                              <Form.Item {...cvFormItemLayout2} label="Position">
                                {getFieldDecorator(`candidate-work-position-${k}`, {
                                  initialValue: i.position,
                                  rules: [{ required: true, message: 'Please input!' }],
                                })(
                                  <Input autoComplete="off" disabled={editLoading} />
                                )}
                              </Form.Item>
                            </Row>
                            <Row>
                              <Form.Item {...cvFormItemLayout2} label="Header Description">
                                {getFieldDecorator(`candidate-work-text-${k}`, {
                                  initialValue: i.text,
                                })(
                                  <TextArea style={{resize: 'none'}} rows={3} autoComplete="off" disabled={editLoading} />
                                )}
                              </Form.Item>
                            </Row>
                            <Row style={{marginBottom: '20px'}}>
                            <Button type="primary" disabled={editLoading} size="small" onClick={() => {
                              addWorkTextDesc(k, '1');
                            }}><Icon type="plus" />Add Level-1 Point</Button>
                            &nbsp;&nbsp;&nbsp;
                            <Button type="primary" disabled={editLoading} size="small" onClick={() => {
                              addWorkTextDesc(k, '2');
                            }}><Icon type="plus" />Add Level-2 Point</Button>
                            </Row>
                            <div>
                            { i.textDesc && i.textDesc.length > 0 ? (
                              <div>
                                {
                                  i.textDesc && i.textDesc.map((each, index) => (
                                    <Row key={`${each.type}-${index}`}>
                                      <Col span={23}>
                                        <Form.Item {...{
                                          labelCol: { span: each.type === 'Level-1' ? 4 : 6 },
                                          wrapperCol: { span: each.type === 'Level-1' ? 20 : 18 },
                                          }} label={`${each.type} Point`}>
                                          {getFieldDecorator(`candidate-work-${k}-textDesc-${index}`, {
                                            initialValue: each.text,
                                            rules: [{ required: true, message: 'Please input!' }],
                                          })(
                                            <TextArea style={{resize: 'none'}} rows={3} autoComplete="off" disabled={editLoading} />
                                          )}
                                        </Form.Item>
                                      </Col>
                                      <Col span={1} style={flexCenter} >
                                        <center style={{marginTop: '25px'}}>
                                          <Popconfirm
                                            placement="left"
                                            title="Are you sure to delete this?"
                                            onConfirm={async () => {
                                              let arr = await getWorkArr();

                                              const tempTextDesc = arr[k]['textDesc'];
                                              tempTextDesc.splice(index, 1);

                                              for (let j = 0; j < tempTextDesc.length; j++) {
                                                form.setFieldsValue({
                                                  [`candidate-work-${k}-textDesc-${j}`]: tempTextDesc[j]['text']
                                                });
                                              }

                                              arr[k] = {
                                                ...arr[k],
                                                ...{textDesc: tempTextDesc}
                                              }

                                              form.setFieldsValue({
                                                work: arr
                                              });
                                            }}
                                            okText="Yes"
                                            cancelText="No"
                                          >
                                            <Icon type="delete" />
                                          </Popconfirm>
                                        </center>
                                      </Col>
                                    </Row>
                                  ))
                                }
                              </div>
                            ) : <div style={{marginBottom: '15px', color: '#cccccc'}}>No bullet points available</div>
                            }
                            <Row>
                              <Form.Item {...cvFormItemLayout2} label="Footer Description">
                                {getFieldDecorator(`candidate-work-footer-${k}`, {
                                  initialValue: i.footer,
                                })(
                                  <TextArea style={{resize: 'none'}} rows={3} autoComplete="off" disabled={editLoading} />
                                )}
                              </Form.Item>
                            </Row>
                            <Row>
                              <Form.Item {...cvFormItemLayout2} label="Add Space">
                                {getFieldDecorator(`candidate-work-space-${k}`, {
                                  initialValue: i.space ? i.space : 0,
                                })(
                                  <InputNumber min={0} max={5} disabled={editLoading}/>
                                )}
                              </Form.Item>
                            </Row>
                            </div>
                          </Col>
                        </Row>
                        <Divider />
                      </div>
                  ))}
                  <Row>
                    <Col span={8} />
                    <Col span={8}>
                      <Button block type="primary" disabled={editLoading} size="large" onClick={() => {
                      const work = form.getFieldValue('work');
                      form.setFieldsValue({
                        work: [
                          ...work,
                          ...[{
                            from: null,
                            to: null,
                            text: '',
                            footer: '',
                            space: 0,
                            company: '',
                            companyDesc: '',
                            position: '',
                            textDesc: [],
                            
                          }]
                        ]
                      });
                    }}><Icon type="plus" />Add New Employment History</Button>
                    </Col>
                    <Col span={8} />
                  </Row>
                </div>
              ) : <div style={{color: '#cccccc'}}>No employment history available</div>}
          </Card>
        </Col>
      </Row>

      <br/>
      <Row>
        <Col span={24}>
          <Card size="small" title={
            <div style={{marginTop: '0px', marginBottom: '-20px'}}>
              <Form.Item>
                {getFieldDecorator('otherTitle1', {
                  initialValue: getOtherTitle1()
                })(
                  <Input style={{width: '250px'}} autoComplete="off" placeholder="Title" disabled={editLoading} />
                )}
              </Form.Item>
            </div>
          } extra={
            <Button type="primary" disabled={editLoading} size="small" onClick={() => {
              const other1 = form.getFieldValue('other1');
              form.setFieldsValue({
                other1: [...other1, ...['']]
              });
            }}><Icon type="plus" />Add New</Button>
          }>
            {
              other1.length > 0 ? (
                <DragDropContext onDragEnd={onDragEndOther1}>
                  <Droppable droppableId="drag-drop">
                    {(provided) => (
                      <div
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                      >
                        {other1.map((i, k) => (
                          <Draggable
                            key={`${i}-${k}`}
                            draggableId={`${i}-${k}`}
                            index={k}
                          >
                            {(p) => (
                              <div
                                ref={p.innerRef}
                                {...p.draggableProps}
                                {...p.dragHandleProps}
                              >
                                <Row key={k}>
                                  <Col span={1}>
                                    <center style={{marginTop: '15px'}}>
                                      <Icon type="menu" />
                                    </center>
                                  </Col>
                                  <Col span={22}>
                                    <Form.Item>
                                      {getFieldDecorator(`candidate-other1-${k}`, {
                                        initialValue: i,
                                        rules: [{ required: true, message: 'Please input!' }],
                                      })(
                                        <TextArea style={{resize: 'none'}} rows={2} autoComplete="off" disabled={editLoading} />
                                      )}
                                    </Form.Item>
                                  </Col>
                                  <Col span={1} style={flexCenter} >
                                    <center style={{marginTop: '15px'}}>
                                      <Popconfirm
                                        placement="left"
                                        title="Are you sure to delete this?"
                                        onConfirm={async () => {
                                          const arr = await getOther1Arr();
                                          arr.splice(k, 1);
                                          for (let i = 0; i < arr.length; i++) {
                                            form.setFieldsValue({
                                              [`candidate-other1-${i}`]: arr[i]
                                            });
                                          }
                                          form.setFieldsValue({
                                            other1: arr
                                          });
                                        }}
                                        okText="Yes"
                                        cancelText="No"
                                      >
                                        <Icon type="delete" />
                                      </Popconfirm>
                                    </center>
                                  </Col>
                                </Row>
                              </div>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              ) : <div style={{color: '#cccccc'}}>Not available</div>}
          </Card>
        </Col>
      </Row>

      <br/>
      <Row>
        <Col span={24}>
          <Card size="small" title={
            <div style={{marginTop: '0px', marginBottom: '-20px'}}>
              <Form.Item>
                {getFieldDecorator('otherTitle2', {
                  initialValue: getOtherTitle2()
                })(
                  <Input style={{width: '250px'}} autoComplete="off" placeholder="Title" disabled={editLoading} />
                )}
              </Form.Item>
            </div>
          } extra={
            <Button type="primary" disabled={editLoading} size="small" onClick={() => {
              const other2 = form.getFieldValue('other2');
              form.setFieldsValue({
                other2: [...other2, ...['']]
              });
            }}><Icon type="plus" />Add New</Button>
          }>
            {
              other2.length > 0 ? (
                <DragDropContext onDragEnd={onDragEndOther2}>
                  <Droppable droppableId="drag-drop">
                    {(provided) => (
                      <div
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                      >
                        {other2.map((i, k) => (
                          <Draggable
                            key={`${i}-${k}`}
                            draggableId={`${i}-${k}`}
                            index={k}
                          >
                            {(p) => (
                              <div
                                ref={p.innerRef}
                                {...p.draggableProps}
                                {...p.dragHandleProps}
                              >
                                <Row key={k}>
                                  <Col span={1}>
                                    <center style={{marginTop: '15px'}}>
                                      <Icon type="menu" />
                                    </center>
                                  </Col>
                                  <Col span={22}>
                                    <Form.Item>
                                      {getFieldDecorator(`candidate-other2-${k}`, {
                                        initialValue: i,
                                        rules: [{ required: true, message: 'Please input!' }],
                                      })(
                                        <TextArea style={{resize: 'none'}} rows={2} autoComplete="off" disabled={editLoading} />
                                      )}
                                    </Form.Item>
                                  </Col>
                                  <Col span={1} style={flexCenter} >
                                    <center style={{marginTop: '15px'}}>
                                      <Popconfirm
                                        placement="left"
                                        title="Are you sure to delete this?"
                                        onConfirm={async () => {
                                          const arr = await getOther2Arr();
                                          arr.splice(k, 1);
                                          for (let i = 0; i < arr.length; i++) {
                                            form.setFieldsValue({
                                              [`candidate-other2-${i}`]: arr[i]
                                            });
                                          }
                                          form.setFieldsValue({
                                            other2: arr
                                          });
                                        }}
                                        okText="Yes"
                                        cancelText="No"
                                      >
                                        <Icon type="delete" />
                                      </Popconfirm>
                                    </center>
                                  </Col>
                                </Row>
                              </div>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              ) : <div style={{color: '#cccccc'}}>Not available</div>}
          </Card>
        </Col>
      </Row>

      <br/>
      <Row>
        <Col span={24}>
          <Card size="small" title={
            <div style={{marginTop: '0px', marginBottom: '-20px'}}>
              <Form.Item>
                {getFieldDecorator('otherTitle3', {
                  initialValue: getOtherTitle3()
                })(
                  <Input style={{width: '250px'}} autoComplete="off" placeholder="Title" disabled={editLoading} />
                )}
              </Form.Item>
            </div>
          } extra={
            <Button type="primary" disabled={editLoading} size="small" onClick={() => {
              const other3 = form.getFieldValue('other3');
              form.setFieldsValue({
                other3: [...other3, ...['']]
              });
            }}><Icon type="plus" />Add New</Button>
          }>
            {
              other3.length > 0 ? (
                <DragDropContext onDragEnd={onDragEndOther3}>
                  <Droppable droppableId="drag-drop">
                    {(provided) => (
                      <div
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                      >
                        {other3.map((i, k) => (
                          <Draggable
                            key={`${i}-${k}`}
                            draggableId={`${i}-${k}`}
                            index={k}
                          >
                            {(p) => (
                              <div
                                ref={p.innerRef}
                                {...p.draggableProps}
                                {...p.dragHandleProps}
                              >
                                <Row key={k}>
                                  <Col span={1}>
                                    <center style={{marginTop: '15px'}}>
                                      <Icon type="menu" />
                                    </center>
                                  </Col>
                                  <Col span={22}>
                                    <Form.Item>
                                      {getFieldDecorator(`candidate-other3-${k}`, {
                                        initialValue: i,
                                        rules: [{ required: true, message: 'Please input!' }],
                                      })(
                                        <TextArea style={{resize: 'none'}} rows={2} autoComplete="off" disabled={editLoading} />
                                      )}
                                    </Form.Item>
                                  </Col>
                                  <Col span={1} style={flexCenter} >
                                    <center style={{marginTop: '15px'}}>
                                      <Popconfirm
                                        placement="left"
                                        title="Are you sure to delete this?"
                                        onConfirm={async () => {
                                          const arr = await getOther3Arr();
                                          arr.splice(k, 1);
                                          for (let i = 0; i < arr.length; i++) {
                                            form.setFieldsValue({
                                              [`candidate-other3-${i}`]: arr[i]
                                            });
                                          }
                                          form.setFieldsValue({
                                            other3: arr
                                          });
                                        }}
                                        okText="Yes"
                                        cancelText="No"
                                      >
                                        <Icon type="delete" />
                                      </Popconfirm>
                                    </center>
                                  </Col>
                                </Row>
                              </div>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              ) : <div style={{color: '#cccccc'}}>Not available</div>}
          </Card>
        </Col>
      </Row>

      <br/>
      <div style={flexCenterRight}>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            {editLoading ? <Icon type="loading" /> : <Icon type="check" />}
            Submit
          </Button>
        </Form.Item>
      </div>
    </Form>
  );
}
const EditCandidateForm = Form.create({ name: 'editCandidate' })(EditCandidate);

export default EditCandidateForm;
